import { render, staticRenderFns } from "./RCdialog.vue?vue&type=template&id=177bc961&"
import script from "./RCdialog.vue?vue&type=script&lang=js&"
export * from "./RCdialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports